const zIndexBackdrop = 6000000;
const zIndexShell = 5999999;
const zIndexNavigation = 5999998;
const zIndexFab = 60;

export {zIndexBackdrop, zIndexShell, zIndexNavigation, zIndexFab};
